
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    balance: 'Home',
    cases: 'Cases',
    games: 'Games',
    inventory: 'Inventory',
    referrals: 'Friends',
    profile: 'Profile',
    menu: 'Menu',
    settings: 'Settings',
  },
  ru: {
    balance: 'Главная',
    cases: 'Кейсы',
    games: 'Игры',
    inventory: 'Инвентарь',
    referrals: 'Друзья',
    profile: 'Профиль',
    menu: 'Меню',
    settings: 'Настройки',
  },
  uz: {
    balance: 'Asosiy',
    cases: 'Keyslar',
    games: 'Oʻyinlar',
    inventory: 'Inventar',
    referrals: 'Doʻstlar',
    profile: 'Profil',
    menu: 'Menyu',
    settings: 'Sozlamalar',
  },
  fa: {
    balance: 'خانه',
    cases: 'کیس‌ها',
    games: 'بازی‌ها',
    inventory: 'انبار',
    referrals: 'دوستان',
    profile: 'پروفایل',
    menu: 'منو',
    settings: 'تنظیمات',
  },
});
